export const INTERNET_OFFLINE_MESSAGE = 'INTERNET_OFFLINE_MESSAGE';

export const IS_PRINTABLE = 'IS_PRINTABLE';
export const IS_LOGIN = 'IS_LOGIN';
export const SETDSP = 'SETDSP';